import App from 'app/app.js';

/**
 * Upstream statuses that mean "this student simply has no yearbook" rather than a fault.
 * A receipt page requests one of these per child, so logging them as errors floods Sentry.
 */
const NOT_FOUND_STATUSES = [204, 404];

function YearbookInfoService($http, loggerService) {
  this.getYearbookHref = function (lifetouchId) {
    if (!lifetouchId) {
      return Promise.resolve(null);
    }

    const url = 'yearBook/getYearBookCode/' + lifetouchId;

    return $http
      .get(url)
      .then(function (response) {
        const data = response?.data;

        if (!data?.success) {
          // A not-found upstream status is an expected outcome, not an error worth reporting.
          if (NOT_FOUND_STATUSES.includes(data?.status)) {
            return null;
          }

          loggerService.error('Yearbook API returned failure', {
            lifetouchId: lifetouchId,
            response: data
          });
          return null;
        }

        // An empty result set is also "no yearbook" — do not log it.
        return data?.data?.[0]?.Link?.Href ?? null;
      })
      .catch(function (error) {
        loggerService.error('Yearbook retrieval error.', {
          lifetouchId: lifetouchId,
          error: error
        });
        return null;
      });
  };
}

App.service('YearbookInfoService', ['$http', 'loggerService', YearbookInfoService]);
